/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";

import { Modal, ModalBody, ModalHeader } from "reactstrap";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

const VideoModal = (props: any) => {
   const { t } = useTranslation("translation", { keyPrefix: "FILE_MANAGER" });


  const {activeFile, setVideoModal, videoModal } = props;

  return (
    <Fragment>
        <Modal
          isOpen={videoModal}
          toggle={() => setVideoModal(false)}
          size="xl"
          centered
        >
          <ModalHeader toggle={() => setVideoModal(false)}>
            {activeFile?.name}
          </ModalHeader>
          <ModalBody style={{ minHeight: 600 }}>
            {activeFile?.presignedUrl && (
              <div style={{ textAlign: "center" }}>
                <video
                  controls
                  style={{ maxWidth: "100%", height: "auto" }}
                >
                  <source src={activeFile.presignedUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            )}
          </ModalBody>
        </Modal>
    </Fragment>
  );
};

export default VideoModal;
